import Keycloak from "keycloak-js";
import { CONFIG } from './config/envConstants';

const keycloakConfig = {
    url: CONFIG.KEYCLOAK_URL,
    realm: CONFIG.KEYCLOAK_REALM,
    clientId: CONFIG.KEYCLOAK_CLIENT_ID,
    initOptions: {
        onLoad: 'login-required',
    }
};
const keycloak = new Keycloak(keycloakConfig);
console.log(keycloakConfig);
export const realm = keycloakConfig.realm;

export default keycloak;